import { render, staticRenderFns } from "./MmfEdit.vue?vue&type=template&id=0efa4012&"
import script from "./MmfEdit.vue?vue&type=script&lang=js&"
export * from "./MmfEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports